import { HierarchyUtils } from '@inter-ikea-core/core';
import { OrganizerComponent } from '../..';
import { PlannerValidation } from './PlannerValidation';
// Validation rule to max stack 4 organizers on top of eachother
export class StackableOrganizersValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'StackableOrganizersValidation');
        this.coreApi = coreApi;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (!entity.hasComponent(OrganizerComponent.id) ||
            !snapActionCandidate.host.hasComponent(OrganizerComponent.id)) {
            return this.validationOK();
        }
        let stackHeight = 1;
        let host = snapActionCandidate.host;
        while (host?.hasComponent(OrganizerComponent.id)) {
            stackHeight = stackHeight + 1;
            host = HierarchyUtils.parent(host);
        }
        return stackHeight > 4
            ? this.validationFail('Can´t stack more than 4 organizers on top of eachother')
            : this.validationOK();
    }
}
//# sourceMappingURL=StackableOrganizersValidation.js.map